var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.fullNameTitle,
        visible: _vm.dialogVisible,
        width: "1000px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "attendanceEmployee",
          attrs: {
            "label-width": "120px",
            model: _vm.attendanceEmployee.arriveEmployeeDate,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticClass: "shift-card" }, [
                  _c("div", { staticClass: "shift-header" }, [
                    _c("strong", [_vm._v("Chấm công đến")]),
                  ]),
                  _c("div", { staticClass: "shift-row" }, [
                    _c(
                      "div",
                      { staticClass: "shift-col shift-media" },
                      [
                        _c("div", { staticClass: "shift-media-title" }, [
                          _vm._v("Ảnh đến"),
                        ]),
                        _c("image-uploader", {
                          attrs: {
                            preview:
                              _vm.attendanceEmployee.arriveEmployeeDate
                                .arrivePicture,
                            placeholder: "Tải ảnh đến",
                            updateAttendance: true,
                          },
                          on: { change: _vm.handleImageChange },
                          model: {
                            value:
                              _vm.attendanceEmployee.arriveEmployeeDate
                                .arrivePictureFile,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.attendanceEmployee.arriveEmployeeDate,
                                "arrivePictureFile",
                                $$v
                              )
                            },
                            expression:
                              "attendanceEmployee.arriveEmployeeDate.arrivePictureFile",
                          },
                        }),
                        _c("div", { staticClass: "shift-time" }, [
                          _vm._v("\n                Giờ đến: "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatTime")(
                                  _vm.attendanceEmployee.arriveEmployeeDate
                                    .arriveTime
                                )
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "shift-col shift-note" },
                      [
                        _c("div", { staticClass: "shift-media-title" }, [
                          _vm._v("Ghi chú"),
                        ]),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            placeholder:
                              "Nhập nội dung / ghi chú cho chấm công đến",
                          },
                          model: {
                            value:
                              _vm.attendanceEmployee.arriveEmployeeDate
                                .arriveContent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.attendanceEmployee.arriveEmployeeDate,
                                "arriveContent",
                                $$v
                              )
                            },
                            expression:
                              "attendanceEmployee.arriveEmployeeDate.arriveContent",
                          },
                        }),
                        _vm.attendanceEmployee.arriveEmployeeDate.createdBy
                          ? _c(
                              "div",
                              {
                                staticClass: "shift-status",
                                staticStyle: { "margin-top": "20px" },
                              },
                              [
                                _vm.attendanceEmployee.arriveEmployeeDate
                                  .createdDate !==
                                _vm.attendanceEmployee.arriveEmployeeDate
                                  .lastModifieDate
                                  ? _c("div", [
                                      _c("strong", [_vm._v("Chấm công:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.attendanceEmployee
                                              .arriveEmployeeDate.lastModifieBy
                                          ) +
                                          "\n                  "
                                      ),
                                      _vm.attendanceEmployee.arriveEmployeeDate
                                        .lastModifieBy !== "Hệ thống"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "6px",
                                              },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v("Thời gian:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      _vm.attendanceEmployee
                                                        .arriveEmployeeDate
                                                        .lastModifieDate
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _c("div", [
                                      _c("strong", [_vm._v("Chấm công:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.attendanceEmployee
                                              .arriveEmployeeDate.createdBy
                                          ) +
                                          "\n                  "
                                      ),
                                      _vm.attendanceEmployee.arriveEmployeeDate
                                        .createdDate !== "Hệ thống"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "6px",
                                              },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v("Thời gian:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      _vm.attendanceEmployee
                                                        .arriveEmployeeDate
                                                        .createdDate
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("attendanceEmployee")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _vm._v(" Đóng\n    "),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("attendanceEmployee")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _vm._v(" Lưu\n    "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }